import React from 'react';
import { Button } from '@/components/ui/button';
import { Star } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useRealtimeSettings } from '@/hooks/useRealtimeSettings';
import { defaultSettings } from '@/types/settings';
const PremiumHeroSection: React.FC = () => {
  const navigate = useNavigate();
  const {
    settings
  } = useRealtimeSettings();
  const currentSettings = settings || defaultSettings;
  const handlePrivateClick = () => {
    navigate('/univers-particuliers');
  };
  const handleProfessionalClick = () => {
    navigate('/evenement-entreprise-prestige');
  };

  // Images responsive avec srcset pour optimisation - ajout 480w pour mobile
  const heroImageBase = '/lovable-uploads/7b97ec36-7bc1-4ec7-9b50-adb7b96660cf.png';
  const heroImageSrcSet = `
    ${heroImageBase}?width=480&quality=60&format=webp&resize=cover 480w,
    ${heroImageBase}?width=768&quality=65&format=webp&resize=cover 768w,
    ${heroImageBase}?width=1200&quality=70&format=webp&resize=cover 1200w,
    ${heroImageBase}?width=1920&quality=70&format=webp&resize=cover 1920w
  `;
  const heroImageSrc = `${heroImageBase}?width=1400&quality=70&format=webp&resize=cover`;
  const heroImageSizes = "(max-width: 480px) 480px, (max-width: 768px) 768px, (max-width: 1200px) 1200px, 1920px";
  
  return <section className="relative" style={{ minHeight: '35vh' }}>
      {/* Hero compact et impactant - explicit height to prevent CLS */}
      <div className="relative flex items-center justify-center min-h-[35vh] md:min-h-[50vh]">
        {/* Image de fond optimisée avec srcset responsive */}
        <div className="absolute inset-0 z-0">
          <img 
            src={heroImageSrc}
            srcSet={heroImageSrcSet}
            sizes={heroImageSizes}
            alt="Organisation évènements Paris Île-de-France - Mariage, anniversaire signature, séminaire sur mesure par Maison Eridia" 
            className="w-full h-full object-cover" 
            loading="eager" 
            fetchPriority="high" 
            decoding="async"
            width={1920}
            height={1080}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/75 to-black/85" />
        </div>

        {/* Contenu du hero */}
        <div className="relative z-10 container mx-auto px-4 text-center py-6 md:py-12 pb-16 md:pb-20">
          <div>
            <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              L'art de sublimer vos instants.
            </h1>
            
            <p className="font-sans text-base md:text-lg lg:text-xl text-white/90 max-w-2xl mx-auto mb-6 leading-relaxed">
              Scénographie et direction artistique d'évènements professionnels et privés sur-mesure.
            </p>

            {/* Note Google */}
            <div className="flex items-center justify-center gap-2.5 mb-9">
              <div className="flex items-center gap-0.5" aria-hidden="true">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 md:h-5 md:w-5 fill-[#C9A96E] text-[#C9A96E]" />
                ))}
              </div>
              <span className="font-semibold text-white text-lg md:text-xl leading-none">5,0</span>
              <span className="text-white/70 text-sm md:text-base leading-none">sur Google</span>
            </div>

            {/* Boutons CTA premium */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Button onClick={handlePrivateClick} variant="outline" className="group relative px-6 sm:px-8 py-5 sm:py-6 text-base md:text-lg font-medium bg-white/10 backdrop-blur-sm border-2 border-white/40 text-white hover:bg-white hover:text-primary hover:border-white rounded-full transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(201,160,108,0.4)] w-full sm:w-auto sm:min-w-[220px]">
                <span className="relative z-10">Je suis un particulier</span>
              </Button>
              
              <Button onClick={handleProfessionalClick} className="group relative px-6 sm:px-8 py-5 sm:py-6 text-base md:text-lg font-medium bg-primary hover:bg-primary-light text-white rounded-full transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(31,42,68,0.5)] shadow-lg w-full sm:w-auto sm:min-w-[220px]">
                <span className="relative z-10">Je suis un professionnel</span>
              </Button>
            </div>
          </div>
        </div>

        {/* (Ancien indicateur de scroll retiré : c'était un motion.div VIDE —
            aucun enfant, donc invisible — qui ne servait qu'à tirer framer-motion
            dans ce composant above-the-fold. Suppression = zéro changement visuel.) */}
      </div>

      {/* Transition fluide avec divider élégant */}
      <div className="relative z-20 pb-8">
        {/* Divider courbé élégant */}
        
        
      </div>
    </section>;
};
export default PremiumHeroSection;